// Ameersha N : 27-11-2023 : BT-116461 Breeze - Addendum and Notices --Start
import { memo, useCallback, useEffect, useMemo,  useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NETWORK_RESPONSE_STATUS } from '../../utils/global_variables';
import { BzButton, BzModal, BzModalBody, BzModalFooter, BzModalHeader } from '../../components';
import AddEndumAndNoticeRejectModal from './AddEndumAndNoticeRejectModal';
import { Col, Container, Row } from 'react-bootstrap';
import { updateIsLoading } from '../../redux/actions/auth';
import { addEndumandNoticeSuccess, updateIsAddenddumModalAction } from '../../redux/actions/addEndumAndNotices';
import { acceptorRejectAddendumAndNotices } from '../../apis/nontransactional';
import { deepClone, getDecryptLocalStorage, setEncryptLocalStorage } from '../../utils/global_functions';
import  DOMPurify  from 'dompurify';


const AddEndumAndNoticesModal = () => {

    const dispatch = useDispatch();
    const [show, setShow] = useState(false);
    const anddEndumNoticesInfo = useSelector(state => state?.addendumreducer?.anddEndumNoticesInfo);
    const isOpen = useSelector(state => state?.addendumreducer?.isOpen);
    const [currentInDex, setCurrentIndex] = useState(1);
    const [isDisabledIcons, setIsDisabledIcons] = useState({
        isLessThanDisabled: false,
        isGraterThanDisabled: false
    });
    const [arrAcceptedIds, setArrAcceptedIds] = useState([]);
    const [arrRejectedIds, setArrRejectedIds] = useState([]);
    const [isButtonEnabled, setIsButtonEnabled] = useState(false);
    const [arrCheckBoxIds, setCheckBoxIds] = useState([]);
    const [isAccepteBtnDisabled, setIsAcceptBtnDisabled] = useState(true);

    const findAndSetNotices = useCallback((selectedNotice) => {
        let copy = anddEndumNoticesInfo;
        let nIndex = anddEndumNoticesInfo?.findIndex(eachNotice => eachNotice?.notice_id === selectedNotice?.notice_id);
        if (nIndex >= 0) {
            copy?.splice(nIndex, 1);
            dispatch(addEndumandNoticeSuccess([...copy]));
        } else {
            dispatch(addEndumandNoticeSuccess([...copy]));
        }
    }, [anddEndumNoticesInfo, dispatch]);

    // Ameersha N : 14-02-2024 : BT-116461 Breeze - Addendum and Notices --Start
    const checkNoticesStatus = useCallback((notices, acceptedIds, rejectedIds) => {
        const allIds = acceptedIds?.concat(rejectedIds);
        for (let notice of notices) {
            if (!allIds?.includes(notice?.notice_id)) {
                return false;
            }

        }
        return true;
    }, []);
    // Ameersha N : 14-02-2024 : BT-116461 Breeze - Addendum and Notices --End
    // Ameersha N : 14-02-2024 : BT-116461 Breeze - Addendum and Notices --Start
    useEffect(() => {
        if (anddEndumNoticesInfo[currentInDex - 1]?.show_checkbox === '1') {
            let nIndex = arrCheckBoxIds?.findIndex(eachId => eachId === anddEndumNoticesInfo[currentInDex - 1]?.notice_id);
            if (nIndex >= 0) {

                setIsAcceptBtnDisabled(false);
            } else {
                setIsAcceptBtnDisabled(true);
            }
        } else {
            setIsAcceptBtnDisabled(false);
        }
    }, [anddEndumNoticesInfo, currentInDex, arrCheckBoxIds]);
    // Ameersha N : 14-02-2024 : BT-116461 Breeze - Addendum and Notices --End

    // Ameersha N : 09-02-2024 : BT-116461 Breeze - Addendum and Notices --Start
    const handleCheckBox = useCallback((id) => {
        let nIndex = arrAcceptedIds?.findIndex(eachId => eachId === id);
        let aIndex = arrCheckBoxIds?.findIndex(eachId => eachId === id);
        if (nIndex >= 0 || aIndex >= 0) {
            return true;
        } else {
            return false;
        }
    }, [arrAcceptedIds, arrCheckBoxIds]);
    // Ameersha N : 09-02-2024 : BT-116461 Breeze - Addendum and Notices --End

    // Ameersha N : 09-02-2024 : BT-116461 Breeze - Addendum and Notices --Start
    const handleChcekcBoxChange = useCallback((id) => {
        let aIndex = arrCheckBoxIds?.findIndex(eachId => eachId === id);
        let copy = arrCheckBoxIds;
        if (aIndex >= 0) {
            copy?.splice(aIndex, 1);
            setEncryptLocalStorage('CHECKBOX_NOTICES_ID', JSON?.stringify([...copy]));
            setCheckBoxIds([...copy]);
        } else {
            copy?.push(id);
            setEncryptLocalStorage('CHECKBOX_NOTICES_ID', JSON?.stringify([...copy]));
            setCheckBoxIds([...copy]);
        }
    }, [arrCheckBoxIds]);
    // Ameersha N : 09-02-2024 : BT-116461 Breeze - Addendum and Notices --End

    // Ameersha N : 09-02-2024 : BT-116461 Breeze - Addendum and Notices --Start
    useEffect(() => {
        let currentNoticeID = anddEndumNoticesInfo[currentInDex - 1]?.notice_id;
        let nIndex = arrAcceptedIds?.findIndex(eachId => eachId === currentNoticeID);
        let aIndex = arrRejectedIds?.findIndex(eachId => eachId === currentNoticeID);
        if (nIndex >= 0 || aIndex >= 0) {
            setIsButtonEnabled(true);
            setIsAcceptBtnDisabled(true);
        } else {
            setIsButtonEnabled(false);
        }
    }, [anddEndumNoticesInfo, currentInDex, arrAcceptedIds, arrRejectedIds]);
    // Ameersha N : 09-02-2024 : BT-116461 Breeze - Addendum and Notices --End

    // Ameersha N : 29-11-2023 : BT-116461 Breeze - Addendum and Notices --Start
    useEffect(() => {
        if (currentInDex === 1) {
            //disabled left
            setIsDisabledIcons(() => {
                return { isGraterThanDisabled: false, isLessThanDisabled: true };
            });
        } else if (currentInDex === anddEndumNoticesInfo?.length) {
            setIsDisabledIcons(() => {
                return { isLessThanDisabled: false, isGraterThanDisabled: true };
            });
        }
        else {
            setIsDisabledIcons({
                isLessThanDisabled: false,
                isGraterThanDisabled: false
            });
        }

    }, [currentInDex, anddEndumNoticesInfo]);
    // Ameersha N : 29-11-2023 : BT-116461 Breeze - Addendum and Notices --End
    // Ameersha N : 27-11-2023 : BT-116461 Breeze - Addendum and Notices --Start
    const onHandleIndex = useCallback((type) => {
        switch (type) {
            case 'next':
                setCurrentIndex(prevState => {
                    if (prevState <= anddEndumNoticesInfo?.length - 1) {
                        return prevState + 1;
                    } else {
                        return prevState;
                    }
                });
                break;
            case 'previous':
                setCurrentIndex(prevState => {
                    if (prevState > 1) {
                        return prevState - 1;
                    } else {
                        return prevState;
                    }
                });
                break;
            default:
                break;
        }
    }, [anddEndumNoticesInfo]);
    // Ameersha N : 27-11-2023 : BT-116461 Breeze - Addendum and Notices --End

    // Ameersha N : 27-11-2023 : BT-116461 Breeze - Addendum and Notices --Start
    const htmlContent = useMemo(() => DOMPurify.sanitize(anddEndumNoticesInfo[currentInDex - 1]?.notice_desc, { ALLOWED_TAGS: [ 'p', 'ul', 'ol', 'li', 'a', 'div', 'span', 'b', 'i', 'strong', 'em', 'br', 'hr', 'table', 'thead', 'tbody', 'tr', 'td', 'th', 'img' ], ALLOWED_ATTR: ['href', 'target', 'src', 'alt', 'title', 'class', 'id'] }), [currentInDex, anddEndumNoticesInfo]);
    const rejectHtmlContent = useMemo(() => anddEndumNoticesInfo[currentInDex - 1]?.log_off_message, [currentInDex, anddEndumNoticesInfo]);
    // Ameersha N : 27-11-2023 : BT-116461 Breeze - Addendum and Notices --End

    // Ameersha N : 09-02-2024 : BT-116461 Breeze - Addendum and Notices --Start
    useEffect(() => {
        let arrCombinedIds = [...arrAcceptedIds, ...arrRejectedIds];
        const copy = deepClone(anddEndumNoticesInfo);
        let xIndex = copy?.findIndex(obj => !arrCombinedIds?.includes(obj?.notice_id));
        if (xIndex === 0) {
            setCurrentIndex(xIndex + 1);
        } else if (xIndex >= 1) {
            setCurrentIndex(xIndex + 1);
        }
        else { }
    }, [arrAcceptedIds, arrRejectedIds, anddEndumNoticesInfo]);
    // Ameersha N : 09-02-2024 : BT-116461 Breeze - Addendum and Notices --End
    // Ameersha N : 09-02-2024 : BT-116461 Breeze - Addendum and Notices --Start
    const isAllIdsAcceptedOrRejected = useCallback(() => {
        if ((arrAcceptedIds?.length + arrRejectedIds?.length) === anddEndumNoticesInfo?.length) {
            return true;
        } else {
            return false;
        }
    }, [arrAcceptedIds, arrRejectedIds, anddEndumNoticesInfo]);
    // Ameersha N : 09-02-2024 : BT-116461 Breeze - Addendum and Notices --End
    // Ameersha N : 09-02-2024 : BT-116461 Breeze - Addendum and Notices --Start
    useEffect(() => {
        if (anddEndumNoticesInfo?.length > 0) {
            let arrLocalAcceptedIds = JSON?.parse(getDecryptLocalStorage('ACCEPTED_NOTICES_ID'));
            let arrLocalRejectedIds = JSON?.parse(getDecryptLocalStorage('REJECTED_NOTICES_ID'));
            let arrLocalChekboxIds = JSON?.parse(getDecryptLocalStorage('CHECKBOX_NOTICES_ID'));
            if (arrLocalChekboxIds) {
                setCheckBoxIds(arrLocalChekboxIds);
            } else {

            }


            if (checkNoticesStatus(anddEndumNoticesInfo, arrLocalAcceptedIds, arrLocalRejectedIds)) {

                dispatch(updateIsAddenddumModalAction(false));
            } else {

                dispatch(updateIsAddenddumModalAction(true));
            }
            if (arrLocalAcceptedIds) {
                setArrAcceptedIds(arrLocalAcceptedIds);
            } else {
                setArrAcceptedIds([]);
            }
            if (arrLocalRejectedIds) {
                setArrRejectedIds(arrLocalRejectedIds);
            } else {
                setArrRejectedIds([]);
            }

        } else {
            dispatch(updateIsAddenddumModalAction(false));
        }

    }, [anddEndumNoticesInfo, checkNoticesStatus, dispatch]);
    // Ameersha N : 09-02-2024 : BT-116461 Breeze - Addendum and Notices --End
    // Ameersha N : 09-02-2024 : BT-116461 Breeze - Addendum and Notices --Start
    const handleAccept = useCallback(async () => {
        dispatch(updateIsLoading(true));
        const payload = {
            accept_or_reject_action: "ACCEPT",
            client_mac_address: "",
            notice_id: anddEndumNoticesInfo[currentInDex - 1]?.notice_id
        };
        const objResp = await acceptorRejectAddendumAndNotices(payload);
        if (objResp?.status === NETWORK_RESPONSE_STATUS?.SUCCESS) {
            // setTimeout(()=>{

            // },500)
            setArrAcceptedIds(prevState => {
                let copy = prevState;
                let nIndex = copy?.findIndex(eachID => eachID === deepClone(anddEndumNoticesInfo[currentInDex - 1]?.notice_id));
                if (nIndex < 0) {
                    copy?.push(deepClone(anddEndumNoticesInfo[currentInDex - 1]?.notice_id));
                    setEncryptLocalStorage('ACCEPTED_NOTICES_ID', JSON?.stringify([...copy]));
                } else { }

                return copy;
            });
            findAndSetNotices(deepClone(anddEndumNoticesInfo[currentInDex - 1]));

            if (isAllIdsAcceptedOrRejected()) {
                dispatch(updateIsAddenddumModalAction(false));
            } else { }
        } else {

        }
    }, [anddEndumNoticesInfo, currentInDex, findAndSetNotices, isAllIdsAcceptedOrRejected, dispatch]);
    // Ameersha N : 09-02-2024 : BT-116461 Breeze - Addendum and Notices --End


    // Ameersha N : 09-02-2024 : BT-116461 Breeze - Addendum and Notices --Start
    const handleReject = useCallback(async () => {
        if (anddEndumNoticesInfo[currentInDex - 1]?.action_on_reject === '0') {
            const payload = {
                accept_or_reject_action: "REJECT",
                client_mac_address: "",
                notice_id: anddEndumNoticesInfo[currentInDex - 1]?.notice_id// current index
            };

            const objResp = await acceptorRejectAddendumAndNotices(payload);
            if (objResp?.status === NETWORK_RESPONSE_STATUS?.SUCCESS) {
                setArrRejectedIds(prevState => {
                    let copy = prevState;
                    let nIndex = copy?.findIndex(eachID => eachID === anddEndumNoticesInfo[currentInDex - 1]?.notice_id);
                    if (nIndex < 0) {
                        copy?.push(anddEndumNoticesInfo[currentInDex - 1]?.notice_id);
                        setEncryptLocalStorage('REJECTED_NOTICES_ID', JSON?.stringify([...copy]));
                    } else { }

                    return copy;
                });
                findAndSetNotices(anddEndumNoticesInfo[currentInDex - 1]);

                if (isAllIdsAcceptedOrRejected()) {
                    dispatch(updateIsAddenddumModalAction(false));
                } else { }
            } else { }
        } else if (anddEndumNoticesInfo[currentInDex - 1]?.action_on_reject === '1') {
            setShow(true);
        } else { }

    }, [anddEndumNoticesInfo, findAndSetNotices, dispatch, isAllIdsAcceptedOrRejected, currentInDex]);
    // Ameersha N : 09-02-2024 : BT-116461 Breeze - Addendum and Notices --End
    // icon-disabled    
    return (
        <>
            <BzModal show={isOpen} className='modal-breeze'>
                <BzModalHeader className='bdr-none'>
                    {anddEndumNoticesInfo[currentInDex - 1]?.notice_title?.length > 0 &&
                        <Container fluid className='p-0 px-3'>
                            <Row className='g-0 pt-3 pb-2 bdr-btm'>
                                <Col className='d-flex justify-content-start'>
                                    <div className='font-medium font-size6 color-text'>{anddEndumNoticesInfo[currentInDex - 1]?.notice_title}</div>
                                </Col>
                            </Row>
                        </Container>
                    }
                </BzModalHeader>
                <BzModalBody>
                    <>
                        <Container fluid className='p-0 px-3'>
                            <Row className='g-0 mt-2'>
                                <Col className='d-flex justify-content-start'>
                                    <div className='font-regular font-size2 color-text text-justify' dangerouslySetInnerHTML={{ __html: htmlContent }}></div>
                                </Col>
                            </Row>
                        </Container>
                    </>
                </BzModalBody>
                <BzModalFooter>
                    <Container fluid className='p-0 px-3 m-0'>
                        {anddEndumNoticesInfo[currentInDex - 1]?.show_checkbox === '1' &&
                            <Row className='g-0 mb-3'>
                                <Col className='d-flex justify-content-start align-items-start'>
                                    <div>
                                        <input data-testid='checkbox-addendum' type='checkbox' className='form-check-input mt-1 me-2' disabled={isButtonEnabled} onChange={() => handleChcekcBoxChange(anddEndumNoticesInfo[currentInDex - 1]?.notice_id)} checked={handleCheckBox(anddEndumNoticesInfo[currentInDex - 1]?.notice_id)} value={anddEndumNoticesInfo[currentInDex - 1]?.checkbox_label} />
                                    </div>
                                    <div>
                                        <label className='font-regular font-size3 color-text text-wrap p-t-3' htmlFor={anddEndumNoticesInfo[currentInDex - 1]?.checkbox_label}>{anddEndumNoticesInfo[currentInDex - 1]?.checkbox_label}</label>
                                    </div>
                                </Col>
                            </Row>
                        }
                        <Row className='g-0'>
                            {anddEndumNoticesInfo?.length===1 ?
                                null
                            :
                                <Col md={4} className='d-flex justify-content-start align-items-center'>
                                    <div className={`icon-14 icon-arrowleft icon-dark ${isDisabledIcons?.isLessThanDisabled ? 'icon-disabled' : ''}`} onClick={() => onHandleIndex('previous')}></div>
                                    <div className='font-medium font-size4 color-subtext px-3'><span className='color-text'>{currentInDex}</span> of {anddEndumNoticesInfo?.length}</div>
                                    <div className={`icon-14 icon-arrowright icon-dark ${isDisabledIcons?.isGraterThanDisabled ? 'icon-disabled' : ''}`} onClick={() => onHandleIndex('next')}></div>
                                </Col>
                            }
                            <Col className='d-flex justify-content-end align-items-center'>
                                {anddEndumNoticesInfo[currentInDex - 1]?.ActionBtns === '2' ?
                                    <>
                                        <Row className='g-0'>
                                            <Col className='d-flex'>
                                                <BzButton data-testid='addendum-reject-button' disabled={isButtonEnabled} className='btn btn-md btn-block btn-outline me-3' onClick={() => handleReject()}>{anddEndumNoticesInfo[currentInDex - 1]?.RejectBtnLabel}</BzButton>
                                                <BzButton data-testid='addendum-accept-button'  autoFocus disabled={anddEndumNoticesInfo[currentInDex - 1]?.show_checkbox === '1' ? isAccepteBtnDisabled : isButtonEnabled} className='btn btn-md btn-block btn-primary' onClick={() => handleAccept()}>{anddEndumNoticesInfo[currentInDex - 1]?.AcceptBtnLabel}</BzButton>
                                            </Col>
                                        </Row>

                                    </> :
                                    <>
                                        <Row className='g-0'>
                                            <Col>
                                                <BzButton persist={true} autoFocus disabled={anddEndumNoticesInfo[currentInDex - 1]?.show_checkbox === '1' ? isAccepteBtnDisabled : isButtonEnabled} className='btn btn-md btn-block btn-primary' onClick={() => handleAccept()}>{anddEndumNoticesInfo[currentInDex - 1]?.AcceptBtnLabel}</BzButton>
                                            </Col>
                                        </Row>
                                    </>
                                }
                            </Col>
                        </Row>
                    </Container>
                </BzModalFooter>
            </BzModal>
            <AddEndumAndNoticeRejectModal currentInDex={currentInDex} show={show} setShow={setShow} htmlContent={rejectHtmlContent} anddEndumNoticesInfo={anddEndumNoticesInfo} />
        </>
    );
};

export default memo(AddEndumAndNoticesModal);
// Ameersha N : 27-11-2023 : BT-116461 Breeze - Addendum and Notices --End